import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UsersIDRequestModel } from "../models/UserModels/UsersIDRequestModel";
import { DepartmentModel } from "../models/DepartmentModels/DepartmentModel";
import { DepartmentUsersIDRequestModel } from "../models/DepartmentModels/DepartmentUsersIDRequestModel";
import { RequestHandlerService ,RequestOptionsModel} from "bbsf-utilities";



@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  ApiUrl = "/api/admin/Department/"
  constructor(private http: RequestHandlerService) {
  }


  addDepartment( AddModel: DepartmentModel) { 
    return this.http.post(this.ApiUrl + 'AddDepartment', AddModel);
  }
  getEditDepartment(id: string) {
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.get(this.ApiUrl + 'EditDeparment', params);

  }
  editDepartment( EditModel: DepartmentModel) {
    return this.http.post( this.ApiUrl + 'EditDeparment', EditModel);
  }
  deleteDepartment(id: string) {
    let params = new HttpParams();
    params = params.append("id", id);
    return this.http.post(this.ApiUrl + 'DeleteDeparment', null, params);
  }
  
  addUsersToDepartment( AddModel: DepartmentUsersIDRequestModel) {
   
    return this.http.post( this.ApiUrl + 'AddUsersToDepartment', AddModel);
  }


  deleteUserFromDepartment( userID:string,DepartmentId:string) {
  
    let params = new HttpParams();
    params = params.append("userID",userID);
    params = params.append("DepartmentId",DepartmentId);

    return this.http.post(this.ApiUrl + 'DeleteUserFromDepartment', null,params);
  }
  getDepartmentInfo(DepartmentId:string) {

    let params = new HttpParams();
    params = params.append("departmentId",DepartmentId);
    return this.http.post(this.ApiUrl + 'GetDepartmentInfo', null, params);
  }
  
  
  
}
